import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

import {
  FINANCING_ENDING_OPERATION_ITEM_RESULT,
  type FinancingEndingOperationItemResult,
} from '../constants/FINANCING_ENDING_OPERATION_ITEM_RESULT';

export const getFinancingEndingOperationItemResultLabel = (
  result: FinancingEndingOperationItemResult
) =>
  match(result)
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.SENT, () => i18n.t('general.labels.sent'))
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.NOT_DELIVERED, () =>
      i18n.t('entity.businessCase.financingEnding.operation.result.deliveryFailed')
    )
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.BLOCKED, () => i18n.t('general.labels.blocked'))
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.PENDING, () => i18n.t('general.labels.pending'))
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.SKIPPED, () =>
      i18n.t('entity.businessCase.financingEnding.operation.result.skipped')
    )
    .with(FINANCING_ENDING_OPERATION_ITEM_RESULT.FAILED, () =>
      i18n.t('general.notifications.labels.failed')
    )
    .exhaustive();
